import React from "react";
import ServiceCard from "./ServiceCard";
import BusinessIcon from '@material-ui/icons/Business';
import CodeIcon from '@material-ui/icons/Code';
import WebIcon from '@material-ui/icons/Web';
import DeveloperModeIcon from '@material-ui/icons/DeveloperMode';
import DevicesIcon from '@material-ui/icons/Devices';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

function Service() {
  return (
    // <div className="bg-[#151418] h-[110vh] pt-20 sm:pt-40">
    <div className=" pt-20 sm:pt-40">
      <div className="flex flex-col items-center">
        <p className="text-2xl sm:text-5xl font-semibold mb-4 pt-8 text-white" data-aos="fade-down" data-aos-delay="400">
          My Awesome Service
        </p>
        <p className="sm:text-lg text-gray-300 w-[75vw] sm:w-[45vw] text-center leading-8 pt-3" data-aos="fade-up" data-aos-delay="500">
          There are some of my services please check out. If you want website
          like this than what are you waiting for Hire Me!
        </p>
      </div>

      <div className=" flex-col flex sm:flex-row  justify-center items-center mt-8 flex-wrap" data-aos="fade-right" data-aos-delay="800">
        <ServiceCard
          heading="Buisness Stratagy"
          para="The strategy defines what the business needs to do to reach its goals. "
          Icon={BusinessIcon}
        />
        <ServiceCard
          heading="Build Websites"
          para="Through my constant learning and practice, my goal is make best websites around. "
          Icon={CodeIcon}
        />
        <ServiceCard
          heading="Make dynamic web Apps"
          para="Dynamic Web Apps have an increased level of technical complexity . "
          Icon={WebIcon}
        />
        <ServiceCard
          heading="Pentration Tester"
          para="Save your buisness and data from the hacker and preventing from breaching data. "
          Icon={DeveloperModeIcon}
        />
        <ServiceCard
          heading="Latest Technologies"
          para="I am always tries to learn new technologies so I can stand with the industry. "
          Icon={DevicesIcon}
        />
        <ServiceCard
          heading="Support"
          para="You get 24 X 7 Support. Any problem from your side is my problem. So get started! "
          Icon={HelpOutlineIcon}
        />

      </div>
    </div>
  );
}

export default Service;
